import React, { Fragment } from 'react'
import { node, string, func } from 'prop-types'
import BackDrop from '../back-drop'


const ModalWrapper = (props) => {
  const {
    titleClassName, title, children, onClose,
  } = props
  return (
    <Fragment>
      <BackDrop color='black' onClick={onClose} />
      <div className="modal-wrapper">
        <div className={titleClassName}>
          {title}
        </div>
        {children}
      </div>
    </Fragment>
  )
}

ModalWrapper.propTypes = {
  titleClassName: string,
  children: node,
  title: string,
  onClose: func,
}

ModalWrapper.defaultProps = {
  titleClassName: '',
  children: null,
  title: '',
  onClose: x => x,
}

export default ModalWrapper
